import React, { ChangeEvent, useEffect, useState } from "react";
import LeaveStyles from "./Leave.styles";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { count } from "console";
import CustomBreadcrumb from "../../global/components/CustomBreadcrumb/CustomBreadcrumb";
import CustomInput from "../../global/components/CustomInput/CustomInput";
import CustomPageHeader from "../../global/components/CustomPageHeader/CustomPageHeader";
import CustomTable from "../../global/components/CustomTable/CustomTable";
import strings from "../../global/constants/StringConstants";
import {
  debounceEventHandler,
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../helpers/methods";

import AttendanceStatusBox from "../Attendance/components/AttendanceStatusBox";
import { MataDataTeamData } from "../../Models/Interface";
import TotalDaysIcon from "../../assets/icons/TotalIcon.svg";
import { LeaveHeader, LeaveTableData } from "./LeaveData";
import SearchIcon from "@mui/icons-material/Search";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import NewLeaveApplication from "./components/NewLeaveApplication/NewLeaveApplication";
import customErrorHandler from "../../utils/customErrorHandler";
import notifiers from "../../global/constants/NotificationConstants";
import { useAppSelector } from "../../utils/hooks";
import { selectUserId } from "../../redux/authSlice";
import {
  GetAllUserLeave,
  getDateWiseLeave,
  getLeave,
  getUserWiseDetails,
  leaveApprove,
} from "./LeaveService";
import moment from "moment";
import filterIcon from "../../assets/icons/filterIcon.svg";
import filter_dropDown from "../../assets/icons/filter_dropDown.svg";
import { store } from "../../utils/store";
import { ReactComponent as VerticalDotIcon } from "../../assets/icons/verticalDot.svg";
import {
  LocalizationProvider,
  PickersShortcutsItem,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  DateRange,
  DateRangePicker,
  StaticDateRangePicker,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import customTableStyles from "../../global/components/CustomTable/customTable.styles";
import dayjs, { Dayjs } from "dayjs";
import { applyLicenseKey } from "../../utils/License";

const breadCrumbList = [
  {
    name: "Team",
  },
  {
    name: "All Leave",
  },
];

const Leave = () => {
  const classes = LeaveStyles;
  const customTableClasses = customTableStyles;
  const privileges = store.getState().auth?.privileges || {};
  const [leaveData, setLeaveData] = useState({
    TotalDays: 0,
  });
  const userRole = store.getState().auth.role;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [rowId, setRowId] = useState("");
  const [isOpenLeveDetailsform, setOpenLeveDetailsform] =
    useState<boolean>(false);
  const [leaveInfo, setLeaveInfo] = useState<any>([
    {
      total_leave: "",
      earned_leave: "",
      sick_leave: "",
      casual_leave: "",
      total_leave_available: "",
      earned_leave_available: "",
      sick_leave_available: "",
      casual_leave_available: "",
    },
  ]);

  const userName = "All Leaves";
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [userLeaveDetails, setUserLeaveDetails] = useState<any>("");
  const userIdFromRedux = useAppSelector(selectUserId);
  const [selectedDateRange, setSelectedDateRange] = useState<any>({});
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [anchorEDate, setAnchorEDate] = useState<null | HTMLElement>(null);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource?.slice(
    pageVisited,
    pageVisited + userPerPage
  );

  useEffect(() => {
    init();
    // getUserLeave();
    tableDataShowHandler();
  }, []);
  useEffect(() => {
    applyLicenseKey();
  }, []);
   useEffect(() => {
    getUserLeave();
    }, [selectedDateRange]);

  const handleDateRangeChange = (newDateRange: any) => {
    if(newDateRange[0] === null && newDateRange[1] === null){
      setOpenDatePicker(false);
      setAnchorEDate(null);
      setSelectedDateRange({ from:null, to:null });
    }else{
      const from = newDateRange[0]?.format("DD-MM-YYYY");
      const to = newDateRange[1]?.format("DD-MM-YYYY");
      if (from && to) {
        setOpenDatePicker(false);
        setAnchorEDate(null);
        setSelectedDateRange({ from, to });
      }
    }
  };

  const shortcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
    {
      label: "This Week",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("week"), today.endOf("week")];
      },
    },
    {
      label: "Last Week",
      getValue: () => {
        const today = dayjs();
        const prevWeek = today.subtract(7, "day");
        return [prevWeek.startOf("week"), prevWeek.endOf("week")];
      },
    },
    {
      label: "Last 7 Days",
      getValue: () => {
        const today = dayjs();
        return [today.subtract(7, "day"), today];
      },
    },
    {
      label: "Current Month",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("month"), today.endOf("month")];
      },
    },
    {
      label: "Next Month",
      getValue: () => {
        const today = dayjs();
        const startOfNextMonth = today.endOf("month").add(1, "day");
        return [startOfNextMonth, startOfNextMonth.endOf("month")];
      },
    },
    {
      label: "Last Year",
      getValue: () => {
        const today = dayjs();
        const prevYear = today.subtract(1, "year");
        return [prevYear.startOf("year"), prevYear.endOf("year")];
      },
    },
    { label: "Reset", getValue: () => [null, null] },
  ];

  const init = async () => {
    try {
      const response = await getLeave(userIdFromRedux);
      console.log("responseresponseww", response);
      customErrorHandler(response);
      setLeaveInfo(response.data);
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const HandleApprove = async (buttonLabel: any) => {
    try {
      const reqApprove: any = buttonLabel === "Approve" ? 1 : 2;
      const response: any = await leaveApprove(
        userIdFromRedux,
        rowId,
        reqApprove
      );
      customErrorHandler(response);
      openSuccessNotification(response.message);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    row_Id: any
  ) => {
    setAnchorEl(event.currentTarget);
    setRowId(row_Id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getUserLeave = async () => {
    try {

       const payload = {
              startDate: selectedDateRange?.from ? selectedDateRange?.from : "",
              endDate: selectedDateRange?.to ? selectedDateRange?.to : "",
            };
      const response = await GetAllUserLeave(payload);
      const modifiedData = response.data.map((item: any) => {
        console.log("itemitem", item);
        const dateRange = item.from_date + " - " + item.to_date;

        let statusText;
        if (item.is_status === "0") {
          statusText = (
            <Typography sx={classes.dataStyle} style={{ color: "orange" }}>
              Pending
            </Typography>
          );
        } else if (item.is_status === "1") {
          statusText = (
            <Typography sx={classes.dataStyle} style={{ color: "green" }}>
              Approved
            </Typography>
          );
        } else if (item.is_status === "2") {
          statusText = (
            <Typography sx={classes.dataStyle} style={{ color: "red" }}>
              Rejected
            </Typography>
          );
        } else {
          statusText = (
            <Typography sx={classes.dataStyle} style={{ color: "red" }}>
              Not found
            </Typography>
          );
        }

        const rowStatus =
          userRole === "Hr" || userRole == "Admin" ? (
            <>
              <Box sx={classes.verticalDotButton}>
                <Button onClick={(event) => handlePopOver(event, item._id)}>
                  <VerticalDotIcon />
                </Button>
              </Box>
            </>
          ) : (
            statusText
          );
        const datePart = item.createdAt.slice(0, 10);
        return {
          createdAt: <>{datePart}</>,
          date_range: <>{dateRange}</>,
          user_name: <>{item.user_name}</>,
          leave_type: item.leave_type,
          total_days: item.total_days,
          comments: item.comments,
          is_status: <>{rowStatus}</>,
        };
      });

      customErrorHandler(response);
      setUserDataSource(modifiedData); // Set the state with the modified data
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  // get value from Input field
  const handleSearchOnChange = async (
    SearchEvent: ChangeEvent<HTMLInputElement>
  ) => {
    if (SearchEvent.target.value) {
      setSearch(SearchEvent.target.value.replace(/\s/g, ""));
    } else {
      setSearch("");
    }
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageNumber(newPage);
  };

  const handleRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const tableDataShowHandler = () => {
    const tableData: any = LeaveTableData.map((item: any, index: any) => {
      return {
        Department: <Typography>{item.Department}</Typography>,
        Designation: item.Designation,
        Action: <Typography>{item.Action}</Typography>,
      };
    });
    setUserDataSource([...tableData]);
    setFixData([...tableData]);
  };

  const handleAddNewLeave = () => {
    setOpenLeveDetailsform(true);
  };

  const handleCloseLeavedetailsForm = () => {
    setOpenLeveDetailsform(false);
  };
  const handelDateRange = async (value: any) => {
    // console.log((value[0]),"newvalue")
    // console.log((value[1]),"newvalue")
    console.log(value[0]?.format("DD/MM/yyyy"), "newvalue");
    console.log(value[1]?.format("DD/MM/yyyy"), "newvalue");
    const from = value[0]?.format("DD/MM/yyyy");
    const to = value[1]?.format("DD/MM/yyyy");
    if (from && to) {
      try {
        const response = await getDateWiseLeave(from, to);
        const modifiedData = response.data.map((item: any) => {
          console.log("itemitem", item);
          const dateRange = item.from_date + " - " + item.to_date;

          let statusText;
          if (item.is_status === "0") {
            statusText = (
              <Typography sx={classes.dataStyle} style={{ color: "orange" }}>
                Pending
              </Typography>
            );
          } else if (item.is_status === "1") {
            statusText = (
              <Typography sx={classes.dataStyle} style={{ color: "green" }}>
                Approved
              </Typography>
            );
          } else if (item.is_status === "2") {
            statusText = (
              <Typography sx={classes.dataStyle} style={{ color: "red" }}>
                Rejected
              </Typography>
            );
          } else {
            statusText = (
              <Typography sx={classes.dataStyle} style={{ color: "red" }}>
                Not found
              </Typography>
            );
          }

          const rowStatus =
            userRole === "Hr" || userRole == "Admin" ? (
              <>
                <Box sx={classes.verticalDotButton}>
                  <Button onClick={(event) => handlePopOver(event, item._id)}>
                    <VerticalDotIcon />
                  </Button>
                </Box>
              </>
            ) : (
              statusText
            );
          const datePart = item.createdAt.slice(0, 10);
          return {
            createdAt: <>{datePart}</>,
            date_range: <>{dateRange}</>,
            user_name: <>{item.user_name}</>,
            leave_type: item.leave_type,
            total_days: item.total_days,
            comments: item.comments,
            is_status: <>{rowStatus}</>,
          };
        });

        customErrorHandler(response);
        setUserDataSource(modifiedData); // Set the state with the modified data
      } catch (error: any) {
        if (customErrorHandler({}, error) === false) return;
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  const getLeavePage = () => {
    return (
      <>
        {/* <CustomBreadcrumb breadCrumbList={breadCrumbList} /> */}
        <Box sx={classes.attendanceWrapper}>
          <CustomPageHeader
            heading={userName}
            subInfo="Manage your team leave here"
          />

          <Grid container>
            {/* <Grid item xs={12}>
                <Box sx={classes.LeaveBoxPart}>
                  <AttendanceStatusBox
                    boxHeading={"Total Leaves"}
                    total={leaveInfo?.total_leave}
                    available={leaveInfo?.total_leave_available}
                    icon={TotalDaysIcon}
                    slash="/"
                  />
                  <AttendanceStatusBox
                    boxHeading={"Earned Leave"}
                    total={leaveInfo?.earned_leave}
                    slash="/"
                    available={leaveInfo?.earned_leave_available}
                    icon={TotalDaysIcon}
                  />
                  <AttendanceStatusBox
                    boxHeading={"Sick Leave"}
                    total={leaveInfo?.sick_leave}
                    available={leaveInfo?.sick_leave_available}
                    icon={TotalDaysIcon}
                    slash="/"
                  />
                  <AttendanceStatusBox
                    boxHeading={"Casual Leave"}
                    total={leaveInfo?.casual_leave}
                    available={leaveInfo?.casual_leave_available}
                    icon={TotalDaysIcon}
                    slash="/"
                  />
                </Box>
              </Grid> */}
            <Grid item xs={6} mt={1}>
              {/* <Box sx={classes.datePickerBox}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateRangePicker
                      onChange={(newValue) => {
                        handelDateRange(newValue);
                      }}
                      localeText={{ start: "start", end: "till" }}
                    />
                  </LocalizationProvider>
                </Box> */}

               {/* <TextField
                                    value={
                                      selectedDateRange?.from && selectedDateRange?.to
                                        ? `${selectedDateRange.from} - ${selectedDateRange.to}`
                                        : ""
                                    }
                                    onClick={(event) => {
                                      setOpenDatePicker(true);
                                      setAnchorEDate(event.currentTarget);
                                    }}
                                    sx={customTableClasses.dateFeild}
                                    inputProps={{
                                      style: { textAlign: 'center' },
                                    }}
                                    placeholder="MM/DD/YYYY - MM/DD/YYYY"
                                  />
                                  <Popover
                                    open={openDatePicker}
                                    anchorEl={anchorEDate}
                                    onClose={() => {         
                                      setOpenDatePicker(false)
                                      setAnchorEDate(null);
                                    }}
                                    // sx={customTableClasses.datePopover}
                                    anchorOrigin={{
                                      vertical: 'bottom',
                                      horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                      vertical: 'top',
                                      horizontal: 'left',
                                    }}
                                  >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <StaticDateRangePicker
                                        onChange={handleDateRangeChange}
                                        slotProps={{
                                          shortcuts: {
                                            items: shortcutsItems,
                                          },
                                          actionBar: { actions: [] },
                                        }}
                                        sx={customTableClasses.dateSelect}
                                      />
                                    </LocalizationProvider>
                                  </Popover> */}
            </Grid>
            <Grid item xs={12} mt={3}>
              {/* <Grid container columnSpacing={2}>
                  <Grid item xs={10}>
                    <Box>
                      <CustomInput
                        placeHolder="Search text"
                        // sx={classes.searchInput}
                        onChange={debounceEventHandler(
                          handleSearchOnChange,
                          strings.SEARCH_TIME_OUT
                        )}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={2}>
                    <Box sx={classes.customButton}>
                      {/* {
                          (privileges && (privileges?.leave?.includes('create') || privileges?.leave?.includes('full control'))) ?
                            <CustomButton
                              label="Add New"
                              onClick={() => {
                                handleAddNewLeave();
                              }}
                              buttonType="primaryBtn"
                            />
                            : ""
                        } 
                    </Box>
                  </Grid>
                </Grid> */}
              <Grid item xs={12}>
                {privileges &&
                (privileges?.["All Leaves"]?.includes("view") ||
                  privileges?.["All Leaves"]?.includes("full control")) ? (
                  <CustomTable
                    headers={LeaveHeader}
                    rows={displayRows}
                    size={[5]}
                    handlePageChange={handleChangePage}
                    handleRowsPerPage={handleRowsPerPage}
                    paginationCount={userCount}
                    rowsPerPage={rowsPerPage}
                    pageNumber={pageNumber}
                  />
                ) : (
                  ""
                )}
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  sx={{ top: "10px", left: "-20px" }}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Box sx={classes.innerPopOver}>
                    <CustomButton
                      label="Approve"
                      onClick={() => {
                        HandleApprove("Approve");
                      }}
                    />
                    <CustomButton
                      label="DisApprove"
                      onClick={() => {
                        HandleApprove("DisApprove");
                      }}
                    />
                  </Box>
                </Popover>
              </Grid>
            </Grid>
          </Grid>

          {isOpenLeveDetailsform && (
            <NewLeaveApplication
              isDialogOpen={true}
              leaveInfo={leaveInfo}
              handleCloseLeavedetailsForm={handleCloseLeavedetailsForm}
            />
          )}
        </Box>
      </>
    );
  };

  return getLeavePage();
};

export default Leave;
